import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { LockComponent } from './pages/lock/lock.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';

import { QuestionnaireResultModule } from './questionnaire-result/questionnaire-result.module';
import { QuestionnaireFillComponent } from './questionnaire-result/questionnaire-fill/questionnaire-fill.component';

import { AuthService } from './auth.service'
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { VerifyRegistrationComponent } from './pages/verify-registration/verify-registration.component';
import { RoleChecker } from '../shared/RoleChecker';
import { Routes } from '@angular/router';

export const routes: Routes = [

    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthService, RoleChecker],
        runGuardsAndResolvers: 'always',
        children: [
            { path: '', redirectTo: 'questionnaire', pathMatch: 'full' },
            { path: 'questionnaire-template', loadChildren: './questionnaire-template/questionnaire-template.module#QuestionnaireTemplateModule' },
            { path: 'questionnaire', loadChildren: './questionnaire/questionnaire.module#QuestionnaireModule' },
            { path: 'user', loadChildren: './user/user.module#UserModule', canActivate: [RoleChecker] },

            { path: 'home', loadChildren: './home/home.module#HomeModule' },
            /*{ path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
            { path: 'widgets', loadChildren: './widgets/widgets.module#WidgetsModule' },
            { path: 'elements', loadChildren: './elements/elements.module#ElementsModule' },
            { path: 'forms', loadChildren: './forms/forms.module#FormsModule' },
            { path: 'charts', loadChildren: './charts/charts.module#ChartsModule' },
            { path: 'tables', loadChildren: './tables/tables.module#TablesModule' },
            { path: 'maps', loadChildren: './maps/maps.module#MapsModule' },
            { path: 'blog', loadChildren: './blog/blog.module#BlogModule' },
            { path: 'ecommerce', loadChildren: './ecommerce/ecommerce.module#EcommerceModule' },
            { path: 'extras', loadChildren: './extras/extras.module#ExtrasModule' },*/
            
        ]
    },

    {
        path: '',
        component: LayoutComponent,
        children: [
            //{ path: 'questionnaire', loadChildren: './questionnaire/questionnaire.module#QuestionnaireModule' },
            { path: 'questionnaire-result', loadChildren: './questionnaire-result/questionnaire-result.module#QuestionnaireResultModule' }
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'recover', component: RecoverComponent },
    { path: 'lock', component: LockComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
    { path: 'reset-password/:token', component: ResetPasswordComponent },
    { path: 'verify-email', component: VerifyRegistrationComponent },
    { path: 'verify-email/:token', component: VerifyRegistrationComponent },
            
    // Not found
    { path: '**', redirectTo: 'home' }

];
